import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router';
import logo from '../../images/logo-medium-transp.png';
import './auth-layout.scss';
import { auth } from '../../firebase/firebase-config';

const AuthLayout = ({ pageName, children }) => {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  const footerLinks = [
    {
      name: "Terms & conditions",
      route: "https://aftawallet.com/terms.html",
    },
    {
      name: "Privacy policy",
      route: "https://aftawallet.com/privacy.html",
    },
  ];

  useEffect(() => {
    if (loading) return;
    if (user) return navigate("/");
  }, [user, loading]);


  const renderLink = (name, route) => (
    <Link to={route}>{name}</Link>
  );

  return loading ? "" :  (
    <div className={`auth-layout ${pageName || ""}`}>
      <div className="auth-sub">
        <div className="con">
          <img src={logo} alt="logo" className="logo" />
          <div className="sub">
            {children}
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="con">
          <p>© 2026 Afta Wallet. All rights reserved</p>
          <nav>
            <ul>
              {footerLinks.map((link, index) => (
                <li key={index}>{renderLink(link.name, link.route)}</li>
              ))}
            </ul>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
